<script lang="ts" setup>
import type { TTeacherProfile } from "@/assets/js/globalTypes";
import api from "@/api";

type TRouteParams = {
	id: string;
};

definePage({
	name: "admin.teachers.public-profile",
});

const route = useRoute();
const isLoading = ref(false);
const teacherData = ref<TTeacherProfile | null>(null);

async function getTeacherData(id: number) {
	isLoading.value = true;

	try {
		const res = await api.getTeacher(id);
		teacherData.value = res.data.data;
	} catch (error) {
		console.error(error);
	} finally {
		isLoading.value = false;
	}
}

watch(
	() => route.path,
	() => {
		const params = route.params as TRouteParams;
		if (params.id) {
			// Ensure id is parsed to number
			getTeacherData(Number(params.id));
		}
	},
	{
		immediate: true,
	},
);
</script>

<template>
	<div id="teacher-indivual-profile">
		<p-button
			:as="'router-link'"
			variant="text"
			:to="{
				name: 'admin.teachers.all',
			}"
			:pt="{
				root: {
					class: 'admin-back-router-link-wrap',
				},
			}"
		>
			<i-ic-chevron-left />
			<span>{{ $t("app.base.back") }}</span>
		</p-button>
		<template v-if="isLoading && !teacherData">
			<div class="progress-spinner">
				<p-progress-spinner />
			</div>
		</template>
		<template v-else-if="!isLoading && !teacherData">
			{{ $t("app.base.no-results") }}
		</template>
		<template v-else>
			<individual-profile-top
				:can-book="false"
				:teacher-data="teacherData"
			/>
			<individual-profile-bottom :teacher-data="teacherData" />
		</template>
	</div>
</template>

<style lang="scss" scoped>
#teacher-indivual-profile {
	.progress-spinner {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 200px;
	}

	.admin-back-router-link-wrap {
		color: $daidai-dark-blue;
		gap: 10px;
		font-size: 1.25rem;
		margin: 0 0 1rem;
		cursor: pointer;

		.faico {
			font-size: 1.5rem;
		}
	}
}
</style>
